import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// This component will automatically scroll to the top of the page
// whenever the route (pathname) changes
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // This component doesn't render anything
};

export default ScrollToTop;
